import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, IconButton, Paper, Typography, Breadcrumbs, Link } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HomeIcon from '@mui/icons-material/Home';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

import OperationProcessWorkflow from '../components/operation-process/OperationProcessWorkflow';
import { useWorkflowTokens } from '../components/operation-process/WorkflowStepCard';
import {
  OperationProcessData,
  OperationProcessService,
} from '../services/OperationProcessService';
import { TEMPLATE_PROJECT_ID } from '../services/OperationProcessFileService';

/**
 * 글로벌 운영 프로세스 템플릿 편집 페이지 — 업무절차 워크플로 디자인.
 * 라우트: /operation-template
 *
 * 여기서 저장한 템플릿은 신규 현장 생성 시 자동으로 복사된다.
 * 모든 변경은 즉시 저장(별도 저장 버튼 없음).
 */
export default function OperationProcessTemplatePage() {
  const navigate = useNavigate();
  const wf = useWorkflowTokens();

  const fetcher = useCallback(() => OperationProcessService.getTemplate(), []);
  const saver = useCallback(
    (data: OperationProcessData) => OperationProcessService.updateTemplate(data),
    []
  );

  return (
    <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column', bgcolor: wf.bg }}>
      <Paper
        elevation={0}
        square
        sx={{
          px: 2.5,
          py: 1.5,
          borderBottom: '1px solid',
          borderColor: 'divider',
          display: 'flex',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <IconButton size="small" onClick={() => navigate('/projects')}>
          <ArrowBackIcon fontSize="small" />
        </IconButton>
        <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
          <Link
            underline="hover"
            color="inherit"
            onClick={() => navigate('/projects')}
            sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 0.5 }}
          >
            <HomeIcon sx={{ fontSize: 16 }} />
            현장 목록
          </Link>
          <Typography color="text.primary" fontWeight={600}>
            운영 템플릿
          </Typography>
        </Breadcrumbs>
      </Paper>

      <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
        <OperationProcessWorkflow
          eyebrow="운영 템플릿"
          title="설치·구축 업무 절차"
          subtitle="여기서 저장한 템플릿은 신규 현장 생성 시 자동으로 복사됩니다. 기존 현장의 데이터는 변경되지 않으며, 변경 사항은 즉시 저장됩니다."
          fetcher={fetcher}
          saver={saver}
          attachmentsProjectId={TEMPLATE_PROJECT_ID}
        />
      </Box>
    </Box>
  );
}
